import { useState } from 'react';

export default function useToken() {

  const getToken = () => {
    const accessToken = localStorage.getItem('token');
    return accessToken
  };

  const [token, setToken] = useState(getToken());

  const saveToken = (userToken:string) => {
    localStorage.setItem('token', userToken);
    setToken(userToken);
  };

  return {
    setToken: saveToken,
    token
  }
}